/* tslint:disable */
/* eslint-disable */
/**
 *
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type { AccessRule, PaginatedAccessRuleList, PatchedAccessRule } from "../models/index";
import {
  AccessRuleFromJSON,
  AccessRuleToJSON,
  PaginatedAccessRuleListFromJSON,
  PaginatedAccessRuleListToJSON,
  PatchedAccessRuleFromJSON,
  PatchedAccessRuleToJSON,
} from "../models/index";

export interface UsersCreateRequest {
  accessRule: Omit<AccessRule, "id" | "url">;
}

export interface UsersDestroyRequest {
  id: string;
}

export interface UsersListRequest {
  page?: number;
}

export interface UsersPartialUpdateRequest {
  id: string;
  patchedAccessRule?: Omit<PatchedAccessRule, "id" | "url">;
}

export interface UsersRetrieveRequest {
  id: string;
}

export interface UsersUpdateRequest {
  id: string;
  accessRule: Omit<AccessRule, "id" | "url">;
}

/**
 *
 */
export class UsersApi extends runtime.BaseAPI {
  /**
   */
  async usersCreateRaw(
    requestParameters: UsersCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<AccessRule>> {
    if (requestParameters["accessRule"] == null) {
      throw new runtime.RequiredError(
        "accessRule",
        'Required parameter "accessRule" was null or undefined when calling usersCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    let urlPath = `/api/users/`;

    const response = await this.request(
      {
        path: urlPath,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: AccessRuleToJSON(requestParameters["accessRule"]),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => AccessRuleFromJSON(jsonValue));
  }

  /**
   */
  async usersCreate(
    requestParameters: UsersCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<AccessRule> {
    const response = await this.usersCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async usersDestroyRaw(
    requestParameters: UsersDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling usersDestroy().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/api/users/{id}/`;
    urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters["id"])));

    const response = await this.request(
      {
        path: urlPath,
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async usersDestroy(
    requestParameters: UsersDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.usersDestroyRaw(requestParameters, initOverrides);
  }

  /**
   */
  async usersListRaw(
    requestParameters: UsersListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedAccessRuleList>> {
    const queryParameters: any = {};

    if (requestParameters["page"] != null) {
      queryParameters["page"] = requestParameters["page"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/api/users/`;

    const response = await this.request(
      {
        path: urlPath,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedAccessRuleListFromJSON(jsonValue)
    );
  }

  /**
   */
  async usersList(
    requestParameters: UsersListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedAccessRuleList> {
    const response = await this.usersListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async usersPartialUpdateRaw(
    requestParameters: UsersPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<AccessRule>> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling usersPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    let urlPath = `/api/users/{id}/`;
    urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters["id"])));

    const response = await this.request(
      {
        path: urlPath,
        method: "PATCH",
        headers: headerParameters,
        query: queryParameters,
        body: PatchedAccessRuleToJSON(requestParameters["patchedAccessRule"]),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => AccessRuleFromJSON(jsonValue));
  }

  /**
   */
  async usersPartialUpdate(
    requestParameters: UsersPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<AccessRule> {
    const response = await this.usersPartialUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async usersRetrieveRaw(
    requestParameters: UsersRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<AccessRule>> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling usersRetrieve().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/api/users/{id}/`;
    urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters["id"])));

    const response = await this.request(
      {
        path: urlPath,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => AccessRuleFromJSON(jsonValue));
  }

  /**
   */
  async usersRetrieve(
    requestParameters: UsersRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<AccessRule> {
    const response = await this.usersRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async usersUpdateRaw(
    requestParameters: UsersUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<AccessRule>> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling usersUpdate().'
      );
    }

    if (requestParameters["accessRule"] == null) {
      throw new runtime.RequiredError(
        "accessRule",
        'Required parameter "accessRule" was null or undefined when calling usersUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    let urlPath = `/api/users/{id}/`;
    urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters["id"])));

    const response = await this.request(
      {
        path: urlPath,
        method: "PUT",
        headers: headerParameters,
        query: queryParameters,
        body: AccessRuleToJSON(requestParameters["accessRule"]),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => AccessRuleFromJSON(jsonValue));
  }

  /**
   */
  async usersUpdate(
    requestParameters: UsersUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<AccessRule> {
    const response = await this.usersUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }
}
